import del from './delete';
import get from './get';
import post from './post';
import put from './put';

export default { del, get, put, post };
